import {
    Box,
    Image,
    Text,
    Stack,
    Badge,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Heading,
    SimpleGrid,
    Spinner,
    Center,
    Divider,
    useColorModeValue,
    Flex,
    Select,
    InputGroup,
    InputLeftElement,
    Input,
    TableContainer,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";
import { useTranslation } from "react-i18next";
import MyPagination from "../../components/MyPagination";
import { SearchIcon } from "@chakra-ui/icons";

const StatCard = ({ label, value }) => (
    <Box
        p={5}
        bg={useColorModeValue("gray.50", "gray.700")}
        rounded="lg"
        shadow="md"
        textAlign="center"
    >
        <Text fontSize="md" fontWeight="medium" mb={2}>
            {label}
        </Text>
        <Text fontSize="2xl" fontWeight="bold">
            {value}
        </Text>
    </Box>
);

const ContentStats = () => {
    const location = useLocation();
    const contentId = location.state?.contentId;
    const [data, setData] = useState(null);
    const [users, setUsers] = useState(null);
    const [episodes, setEpisodes] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()
    const { t } = useTranslation()
    const tableBg = useColorModeValue("gray.50", "gray.700")
    const [currentEpisodePage, setCurrentEpisodePage] = useState(0);
    const [currentUserPage, setCurrentUserPage] = useState(0);
    const [episodesPaginationData, setEpisodesPaginationData] = useState()
    const [userPaginationData, setUserPaginationData] = useState()
    const [userSearchTerm, setUserSearchTerm] = useState("");

    // Function to format duration from seconds to readable format
    const formatDuration = (seconds) => {
        if (!seconds || seconds === 0) return "0 sec";

        const days = Math.floor(seconds / (24 * 3600));
        const hours = Math.floor((seconds % (24 * 3600)) / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);

        const parts = [];
        if (days > 0) parts.push(`${days} jour${days > 1 ? 's' : ''}`);
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}min`);
        if (secs > 0 || parts.length === 0) parts.push(`${secs}sec`);

        return parts.join(' ');
    };
    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 5;
    const [pageSizeUsers, setPageSizeUsers] = useState(PAGE_SIZE);
    const [pageSizeEpisodes, setPageSizeEpisodes] = useState(PAGE_SIZE);

    const handlePageSizeEpisodeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSizeEpisodes(newSize);
        setCurrentEpisodePage(0);
    };
    const handlePageSizeUserChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSizeUsers(newSize);
        setCurrentUserPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        if (contentId) {
            console.log(currentUserPage);
            console.log(pageSizeUsers);
            axiosClient
                .get(`content_stats/${contentId}/?user_page_size=${pageSizeUsers}&user_page=${currentUserPage + 1}&episode_page_size=${pageSizeEpisodes}&episode_page=${currentEpisodePage + 1}&user_search=${userSearchTerm.trim()}`)
                .then((response) => {
                    let filteredUserData = response.data.users;
                    setUserPaginationData(response.data.users_pagination);
                    setUsers(filteredUserData)

                    let filteredEpisodesData = response.data.episodes;
                    setEpisodesPaginationData(response.data.episodes_pagination);
                    setEpisodes(filteredEpisodesData)

                    setData(response.data)

                })
                .catch((err) => console.error(err))
                .finally(() => setLoading(false));
        }


    }, [contentId, pageSizeUsers, pageSizeEpisodes, currentUserPage, pageSizeEpisodes,currentEpisodePage, userSearchTerm]);

    if (loading) {
        return (
            <Center h="100vh">
                <Spinner size="xl" />
            </Center>
        );
    }

    if (!data) {
        return (
            <Center h="100vh">
                <Text fontSize="xl" color="red.500">
                    ID de contenu non valide ou état manquant.
                </Text>
            </Center>
        );
    }
    return (
        <Box >
            <Flex pt='12px' mb={5}>
                <Box >
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray">
                        <span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >
                            {t("Accueil")}
                        </span>  / <span onClick={() => navigate('/contents-stats')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"}>{t("Statistiques de visionnage")}</span>
                        / <span >{data.title}</span>
                    </Text>
                </Box>
            </Flex>
            <Stack p={{ base: 4, md: 10 }} maxW="1200px" mx="auto" spacing={8} align="center">
                <Flex
                    direction={{ base: "column", xl: "row" }}
                    align={"center"}
                    justify="space-between"
                    w="100%"
                    gap={10}
                >
                    {/* Left Side: Image + Title */}
                    <Flex direction="row" gap={4} align="center">
                        <Image
                            borderRadius="xl"
                            boxSize="180px"
                            objectFit="cover"
                            src={data.image}
                            alt={data.title}
                            shadow="lg"
                        />
                        <Box>
                            <Heading fontSize="2xl">{data.title}</Heading>
                            <Badge
                                mt={2}
                                fontSize="md"
                                colorScheme={data.type === "movie" ? "green" : "blue"}
                            >
                                {data.type.toUpperCase()}
                            </Badge>
                        </Box>
                    </Flex>

                    {/* Right Side: Stat Cards */}
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w={{ base: "100%", xl: "60%" }}>
                        <StatCard label="Nombre total de vues" value={data.total_views} />
                        <StatCard
                            label="Durée moyenne de visionnage"
                            value={formatDuration(data.average_watch_duration)}
                        />
                    </SimpleGrid>
                </Flex>

                <Divider />

                <Box  p={4}
                    bg={tableBg}
                    rounded="lg"
                    shadow="md"
                    w="100%">
                    <Flex gap={5} direction={{base:"column", md:'row'}} mb={5} justifyContent={"space-between"} align={"center"}>
                        <Heading size="md" w={{ base: '100%', lg: "40%" }}>
                            Utilisateurs
                        </Heading>

                        <InputGroup size="md" w={{ base: '100%', lg: "40%" }}>
                            <InputLeftElement
                                pointerEvents='none'
                                children={<SearchIcon color='gray.300' />}
                            />
                            <Input
                                style={{ border: '1px solid #CBD5E0' }}

                                borderRadius="5"
                                placeholder={t("Recherche...")}
                                value={userSearchTerm}
                                onChange={(e) => {
                                    setUserSearchTerm(e.target.value);
                                    setCurrentUserPage(0);
                                }}

                                sx={{
                                    marginLeft: 'auto',
                                }}
                            />  </InputGroup>
                    </Flex>
                    <TableContainer>

                        <Table variant="simple" size="sm">
                            <Thead>
                                <Tr>
                                    <Th>Prénom</Th>
                                    <Th>Nom</Th>
                                    <Th>Email</Th>
                                    <Th>Numéro de téléphone</Th>
                                    <Th isNumeric>Nombre total de vues</Th>
                                    <Th isNumeric>Durée moyenne de visionnage</Th>
                                    <Th >dernière vision à</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {users.map((user, index) => (
                                    <Tr key={index}>
                                        <Td>{user.first_name || "N/A"}</Td>
                                        <Td>{user.last_name || "N/A"}</Td>
                                        <Td>{user.email || "N/A"}</Td>
                                        <Td>{user.tel || "N/A"}</Td>
                                        <Td isNumeric>{user.total_views}</Td>
                                        <Td isNumeric>{formatDuration(user.average_watch_duration)}</Td>
                                        <Td >{new Date(user.last_watched).toLocaleString("fr-FR", {
                                            month: "2-digit",
                                            day: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: false,
                                        })}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {/* Pagination */}
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={userPaginationData}
                                currentPage={currentUserPage}
                                setCurrentPage={setCurrentUserPage}
                                PAGE_SIZE={pageSizeUsers}
                            />
                        </Box>

                        <Select w="70px" value={pageSizeUsers} onChange={handlePageSizeUserChange}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            {/* Add more options as needed */}
                        </Select>
                    </Flex>
                </Box>

                {data.type === "series" && (
                    <>
                        <Divider />
                        <Box
                            p={4}
                            bg={tableBg}
                            rounded="lg"
                            shadow="md"
                            w="100%">
                            <Heading size="md" mb={4}>
                                Episodes
                            </Heading>
                            <Table variant="simple" size="sm">
                                <Thead>
                                    <Tr>
                                        <Th>Titre</Th>
                                        <Th isNumeric>Saison</Th>
                                        <Th isNumeric>Episode</Th>
                                        <Th isNumeric>Nombre total de vues</Th>
                                        <Th isNumeric>Durée moyenne de visionnage</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {episodes.map((ep) => (
                                        <Tr key={ep.episode_id}>
                                            <Td>{ep.episode_title}</Td>
                                            <Td isNumeric>{ep.season}</Td>
                                            <Td isNumeric>{ep.episode_number}</Td>
                                            <Td isNumeric>{ep.total_views}</Td>
                                            <Td isNumeric>{formatDuration(ep.average_watch_duration)}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                            {/* Pagination */}
                            <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                                <Box flex="1">
                                    <MyPagination
                                        paginationData={episodesPaginationData}
                                        currentPage={currentEpisodePage}
                                        setCurrentPage={setCurrentEpisodePage}
                                        PAGE_SIZE={pageSizeEpisodes}
                                    />
                                </Box>

                                <Select w="70px" value={pageSizeEpisodes} onChange={handlePageSizeEpisodeChange}>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    {/* Add more options as needed */}
                                </Select>
                            </Flex>
                        </Box>
                    </>
                )}
            </Stack>
        </Box>
    );
};

export default ContentStats;